/**
 * @fileoverview added by tsickle
 * Generated from: providers/config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { InjectionToken } from '@angular/core';
var InfraConfig = /** @class */ (function () {
    function InfraConfig(init) {
        if (init === void 0) { init = {}; }
        this.API_ROOT = init.API_ROOT || '';
    }
    return InfraConfig;
}());
if (false) {
    /** @type {?} */
    InfraConfig.prototype.API_ROOT;
}
/**
 * @param {?} config
 * @return {?}
 */
function setupInfraConfig(config) {
    return new InfraConfig(config);
}
/** @type {?} */
var INFRA_CONFIG_TOKEN = new InjectionToken('infraConfigToken');
export { InfraConfig, INFRA_CONFIG_TOKEN, setupInfraConfig };
